import { Chip } from "@mui/material";
import { ENTERPRISE_TEAL } from "../colors";

export const EnterprisePill = () => (
  <Chip
    label="ENTERPRISE"
    size="small"
    style={{
      backgroundColor: ENTERPRISE_TEAL,
      color: "#FFFFFF",
      fontWeight: 800,
      fontSize: 11,
      height: 20,
      letterSpacing: "0.05em",
    }}
  />
);

export default EnterprisePill;
